module.exports = __webpack_public_path__ + "static/img/z3.b045287d.png";